import { render, staticRenderFns } from "./UserTypeList.vue?vue&type=template&id=5712cd74&scoped=true"
import script from "./UserTypeList.vue?vue&type=script&lang=js"
export * from "./UserTypeList.vue?vue&type=script&lang=js"
import style0 from "./UserTypeList.vue?vue&type=style&index=0&id=5712cd74&prod&scoped=true&lang=css"
import style1 from "./UserTypeList.vue?vue&type=style&index=1&id=5712cd74&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712cd74",
  null
  
)

export default component.exports